module.exports = __webpack_public_path__ + "static/media/upload.b81fef7d.gif";